import { FileDisplayBlock as FileDisplayBlockType } from '../../types/blueprint'
import { DisplayAttachments } from '../DisplayAttachments'

import DocumentViewer from '@/components/shared-components/DocumentViewer'
import { PDF } from '@/config/constants/fileTypes'
import { useTemplateRenderer } from '@/context/templateRendererContext'
import { extensionFromUrl } from '@/modules/attachments/attachmentHelpers'

type Props = {
  block: FileDisplayBlockType
}

export const FileDisplayBlock: React.FC<Props> = ({ block }) => {
  const { fileList } = block
  const { renderOptions } = useTemplateRenderer()

  if (!fileList || fileList.length === 0) return null

  if (
    !renderOptions.renderingInPdf &&
    fileList.length === 1 &&
    extensionFromUrl(fileList[0].url) === PDF
  ) {
    return (
      <DocumentViewer
        url={fileList[0].url}
        name={fileList[0].name}
        contentType={'pdf'}
      />
    )
  }

  return (
    <DisplayAttachments
      title=""
      renderingInPdf={renderOptions.renderingInPdf} // still allow clicking in acceptAll mode
      attachments={fileList.map((f) => ({
        id: f.attachmentId,
        url: f.url,
        thumbnailUrl: f.thumbnailUrl,
        name: f.name,
      }))}
    />
  )
}
